import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal } from 'react-bootstrap';
import "./OrderCompletedCancel.css";
import { useParams,Link,NavLink } from "react-router-dom";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastsuccess,gettoastwarning } from '../../Utils/Common';




const OrderCompletedCancel = () => {
	
	const [loading,setLoading] = useState(true);
	
	const { order_number } = useParams();
  const [show, setShow] = useState(false);

  const [inputsm,setInputsm] = useState({id:'',ticket_id:'',ticket_name:'',ticket_number:'',first_name:'',last_name:'',age:'',email:'',mobile_number:'',qr_code:'',amount:0,status:0});
  

  useEffect(() => {
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth',
		});
    document.title = `Order Completed | Your Friend My Friend`;
    document.getElementById('bodywrap').className='ordercomplete';
	
	
	/* Start get order data */
		let formData = new FormData(); 
		formData.append('ticket_number', order_number);
		API.post('get_ticket_detail_for_web',formData)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
				setInputsm({
					id:response.data.data.id,
					ticket_id:response.data.data.ticket_id,
					ticket_name:response.data.data.ticket_name,
					ticket_number:response.data.data.ticket_number,
					first_name:response.data.data.first_name,
					last_name:response.data.data.last_name,
					age:response.data.data.age,
					email:response.data.data.email,
					mobile_number:response.data.data.mobile_number,
					qr_code:response.data.data.qr_code,
					amount:response.data.data.amount,
					status:response.data.data.status,
				});
				
			}                  
		}).catch(error => {
			 
		});    
	 /* End get order data */
	
  },[order_number]);

const send_to_my_email = (event,ticket_number) => {
	event.preventDefault();
	setLoading(true);
	let formData = new FormData(); 
	formData.append('ticket_number', ticket_number);
	API.post('send_to_my_email',formData)
		.then(response => {
			setLoading(false);
		if(response.data.status === false){
			gettoastwarning(response.data.message,'');
		}else{
			gettoastsuccess(response.data.message,'');
		}                  
	}).catch(error => {
		 
	});  
}

const cancel_ticket = () => {
	
	setLoading(true);
	let formData = new FormData(); 
	formData.append('ticket_number', order_number);
	formData.append('amount', inputsm.amount);
	API.post('web_canceled',formData)
		.then(response => {
			setLoading(false);
		if(response.data.status === false){
			gettoastwarning(response.data.message,'');
			
		}else{
			var url_link='/order-completed-cancel/'+order_number;
			gettoastsuccess(response.data.message,url_link);
			
		}                  
	}).catch(error => {
		 
	});  
}

/* Start show delete varification modal */
const handleShow = (id) => {	
	setShow(true);
}
/* End show delete varification modal */
const handleClose = () => setShow(false);
  

  return (
    <>
      <div className="container py-5">
        <div className="comple">
          <div className="row">
            <div className="col-md-12 order-first">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-right.png'}
                alt="modal-right"
                className="img-fluid"
              />
              <h3>Order completed</h3>
              <p>
                Thank you for your purchase—your ticket(s) are booked, and a
                confirmation email is on its way to your inbox! You will receive
                a copy of the tickets in your email.
              </p>
            </div>
          </div>	
			
			<div className="row d-flex align-items-center uio">
				<div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0">
				  <h3>{inputsm.first_name} {inputsm.last_name}, {inputsm.age}</h3>
				  <p>
					{inputsm.email}
					<br />
					{inputsm.mobile_number}
				  </p>
				</div>
				<div className="col-md-6 col-sm-6 col-6 text-end p-0 links">
				  <div className="orak">
					<button  onClick={(event) => send_to_my_email(event,inputsm.ticket_number)}>Send to my email</button>
						{inputsm.status!==2 ?<button  onClick={(event) => handleShow()}>Cancel ticket</button>: null }
				  </div>
				  
				</div>
				
				{inputsm.status===2 ?<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
					<p className="text-center text-danger">Your ticket has been cancelled. </p>
				</div>: null}
			  </div>
			
			
          

          <div className="row d-flex align-items-center text-center text-md-start apple"> 
            <div className="col-md-12 col-lg-6 p-0 mb-3 mb-lg-0">
              <h2> Get the app </h2>
              <p>
                Save your tickets and find your events in your account in the
                app!
              </p>
            </div>
            <div className="col-md-12 col-lg-6 p-0 text-center text-lg-end">
              <Link href="#">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-app.png'}
                  alt="App Store"
                  className="me-2"
                />
              </Link>
              <Link href="#">
                <img src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-google.png'} alt="Google Play" />
              </Link>
            </div>
			<div className="text-center mt-5">
              <Link className="btn brow-bu text-decoration-none" to="/upcoming-events">View More Events</Link>
            </div>
          </div>
        </div>
      </div>

{/* ========== Delete Popup Start ========== */}
		
		
		
		<Modal show={show} onHide={handleClose} centered >
        <div className="south cencel-pop-box" >
           <Modal.Header>
			  <h3 className="mdlttltxt">Are you sure you want to cancel?</h3>
		   </Modal.Header>
         
          <Modal.Body>
            <Row>
				 <Col className="btn-clr">
				 <NavLink to="#" onClick={cancel_ticket}><Button variant="">Yes</Button></NavLink>
				 </Col>
				 <Col className="btn-dv">
				 <NavLink to="#" onClick={handleClose}><Button variant="">No</Button></NavLink>
				 </Col>
			  </Row>
          </Modal.Body>
          
        </div>
      </Modal>
		
	  {/* ========== Delete Popup End ========== */}
      
	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
    </>
  );
};

export default OrderCompletedCancel;
